import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';
import customIsoString from 'utilities/custom-iso-string';
import Modal from 'react-responsive-modal';
import './Planning.module.scss';
import { notify, removeNotifications } from 'reapop';

/**
 * Import components
 */
import Checkbox from 'components/UI/Checkbox/Checkbox';
import TaskCard from 'components/UI/TaskCard/TaskCard';
import Plannables from 'components/UI/Popup/Plannables/Plannables';
import Tip from 'components/UI/Popup/Tip/Tip';
import { tipsArray } from 'screens/Tips/Tips';
import InputMisc from 'components/UI/Popup/InputMisc/InputMisc';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

/**
 * Import actions
 */
import indexTask from 'actions/task/index';
import updateTask from 'actions/task/update';
import homeworkUpdate from 'actions/homework/update';
import destroyTask from 'actions/task/destroy';
import { toggleTimeVisible, toggleOtherTaskVisible } from 'actions/agenda/index.js';

/**
 * Import selectors
 */

import getTasksThatNeedPlanning from 'selectors/task/task-need-planning';

const mapStateToProps = (state, props) => {
    return {
        agendaVisibility: state.agenda,
        task: state.task.entities,
        homework: state.homework.entities,
        tasksThatNeedPlanning: getTasksThatNeedPlanning(state, props),
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    indexTask,
    updateTask,
    homeworkUpdate,
    toggleTimeVisible,
    toggleOtherTaskVisible,
    destroyTask,
    notify,
    removeNotifications
};

class Planning extends Component {
    constructor() {
        super();

        this.state = {
            currentTaskDeadline: null,
            showPopup: false,
            currentTaskDate: null,
            showTip: false,
            showInputMisc: false,
        };

        this.handleToggle       = this.handleToggle.bind(this);
        this.onDragEnd          = this.onDragEnd.bind(this);
        this.onDragStart        = this.onDragStart.bind(this);
        this.closeTip           = this.closeTip.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setWrapperRef      = this.setWrapperRef.bind(this);
        this.togglePopup        = this.togglePopup.bind(this);
        this.showInputMisc      = this.showInputMisc.bind(this);
        this.hideInputMisc      = this.hideInputMisc.bind(this);
    }

    componentDidMount() {
        this.props.indexTask().then(() => {

            let openTasks = this.props.tasksThatNeedPlanning;

            if (openTasks) {
                // let homework = this.props.homework.allIds.map((homeworkId) => this.props.homework.byId[homeworkId]);

                var today = new Date();
                var date = customIsoString(today, true);

                openTasks.map((task, index) => {
                    if (!task.homework_id) {
                        return;
                    }
                    let homework = this.props.homework.byId[task.homework_id];
                    if (!homework) {
                        return;
                    }

                    if (homework.date < date) {
                        this.props.destroyTask(task.id);
                    }
                });
            }
        });

        //show random tip
        let random = Math.floor((Math.random() * 5) + 1); //generate random number between 1 and 5
        if (random === 2) { //select a number to create a chance of 1 out of 5
            let tip = Math.floor((Math.random() * tipsArray.length));
            this.setState({ showTip: tip });
            setTimeout(() => {
                this.setState({ showTip: false });
            }, 20000);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        //block update when we are updating task order
        if (this.state.blockUpdates == true && nextState.blockUpdates != false) {
            return false;
        }
        return true;
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleToggle(e) {
        e.stopPropagation();
    }

    onDragStart(draggable) {
        let taskId = draggable.draggableId;
        taskId = taskId.split('-')[1];

        const task = this.props.task.byId[taskId];
        if (task.homework_id) {
            const homework = this.props.homework.byId[task.homework_id];
            this.setState({ currentTaskDeadline: new Date(homework.date) });
            
        }
        if (task.date) {
            this.setState({ currentTaskDate: task.date, currentTaskDateObject: new Date(task.date) });
        }
        //pass drag status to parent component so we can disable adding days
        this.props.handleDragUpdate(true);

    }

    onDragEnd(result) {
        const { destination, source, draggableId } = result;

        let taskId = draggableId;
        taskId = taskId.split('-')[1];

        const task = this.props.task.byId[taskId];
        this.setState({ currentTaskDeadline: false,  currentDate: false, blockUpdates: true, currentTaskDate: null, currentTaskDateObject: null });

        //reset drag status in parent component to enable adding days again
        this.props.handleDragUpdate(false);

        if (!destination) {
            this.setState({ blockUpdates: false });
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            this.setState({ blockUpdates: false });
            return;
        }

        if (destination.droppableId == 'plannablesDroppable') { //check if user tried to drop Droppable on Plannables list
            this.setState({ blockUpdates: false });
            return;
        }

        this.props.notify({
            message: 'Taken worden bijgewerkt...',
            status: 'success',
            position: 'tc'
        });

        let newTask = {
            ...task,
            order: destination.index,
            date: destination.droppableId
        };

        this.props.updateTask(newTask)
            .then((result) => {

                let taskUpdatesPromises = [];

                //check if this task was the last task for this homework (so we can mark it planned)
                if (newTask.homework_id && this.props.tasksThatNeedPlanning.filter((task) => task.homework_id == newTask.homework_id).length == 0) {

                    let homework = this.props.homework.byId[newTask.homework_id];

                    //update homework to reflect planned state
                    this.props.homeworkUpdate({
                        ...homework,
                        note: homework.note ? homework.note : '',
                        hasBeenPlanned: true
                    });

                }

                if ((destination.index < source.index) || (destination.droppableId != source.droppableId)) { //omhoog verplaatst of taak uit andere colom
        
                    let tasksThatNeedReorder = this.props.task.allIds.map((taskId) => this.props.task.byId[taskId])
                        .filter((task) => {
                            if (destination.droppableId == source.droppableId) { //when in the same column, we only need to adjust up to the point of the source index
                                return task.date == destination.droppableId
                                && task.order >= destination.index
                                && task.order <= source.index
                                && task.id != newTask.id;
                            } else { //when we came from another column, we need to adjust the whole column all the way down
                                return task.date == destination.droppableId
                                && task.id != newTask.id
                                && task.order >= destination.index;
                            }
                        })
                        .sort((a, b) => a.order - b.order);
                    tasksThatNeedReorder.map((task) => {
                        if (task.id == draggableId) return;
                        taskUpdatesPromises.push({ func: this.props.updateTask, arg: {
                            ...task,
                            order: (task.order + 1)
                        }});
                    });
        
        
                    if (destination.droppableId != source.droppableId) { //the object was from another column so we need to adjust that column as well
                        tasksThatNeedReorder = this.props.task.allIds.map((taskId) => this.props.task.byId[taskId])
                            .filter((task) => task.date == source.droppableId && task.order > source.index)
                            .sort((a, b) => a.order - b.order);
                        tasksThatNeedReorder.map((task) => {
                            if (task.id == draggableId) return;
                            taskUpdatesPromises.push({ func: this.props.updateTask, arg: {
                                ...task,
                                order: (task.order - 1)
                            }});
                        });
                    }
        
                } else { //down
                    let tasksThatNeedReorder = this.props.task.allIds.map((taskId) => this.props.task.byId[taskId]).
                        filter((task) =>
                            task.date == destination.droppableId 
                        && task.order <= destination.index
                        && task.order > source.index
                        && task.id != newTask.id)
                        .sort((a, b) => a.order - b.order);
                    tasksThatNeedReorder.map((task) => {
                        if (task.id == draggableId) return;
                        taskUpdatesPromises.push({ func: this.props.updateTask, arg: {
                            ...task,
                            order: (task.order - 1)
                        }});
                    });
                }
                //execute all UpdateTask promises
                Promise.all(taskUpdatesPromises.map( (prom) => prom.func(prom.arg) )).then(() => {
                    //when finished, allow updates again to rerender new order
                    this.setState({ blockUpdates: false });
                    this.props.removeNotifications();
                });

            }).catch((error) => {alert('Er ging iets mis met het bijwerken van de taak'); console.error(error);});
    }

    closeTip() {
        this.setState({
            showTip: false
        });
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                showPopup: false
            });
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }

    togglePopup() {
        if (!this.state.showPopup) {
            document.addEventListener('mousedown', this.handleClickOutside);
        } else {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
        this.setState(prevState => {
            return {
                showPopup: !prevState.showPopup
            };
        });
    }

    showInputMisc(date) {
        this.setState({
            showInputMisc: true,
            inputMiscDate: customIsoString(date, true)
        });
    }

    hideInputMisc() {
        this.setState({
            showInputMisc: false,
        });
    }

    render() {
        const { showPlanning, switchPlanning, scrollHandler } = this.props;
        let taskCards = [];
        let today;

        if (this.props.centerDay) {
            today = new Date(this.props.centerDay);
        } else {
            today = new Date();
        }

        //create past days
        for (let index = (-1 * this.props.daysPast); index < 0; index++) {
            let currentDate;
            let past;

            if (this.props.centerDay) {
                currentDate = new Date(this.props.centerDay);
                currentDate.setHours(22);
                currentDate.setDate(today.getDate()+index);
                past = new Date() > currentDate;
            } else {
                currentDate = new Date();
                currentDate.setDate(today.getDate()+index);
                past = true;
            }

            let currentTaskDeadline = null;
            let todayForCheck = '';

            if (this.state.currentTaskDeadline) {
                currentTaskDeadline = this.state.currentTaskDeadline;
                currentTaskDeadline.setHours(22);
            }

            if (this.state.currentTaskDate) {
                //build date string to compare currentTaskDate with
                //we use this to check if the task that we are dragging originates from today, if so the taskCard should not be disabled. 
                //this is to prevent visual issues when the card is Disabled.
                todayForCheck = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1 < 10 ? `0${currentDate.getMonth() + 1}` : currentDate.getMonth() + 1}-${currentDate.getDate()}`;
            }
            taskCards.push(<TaskCard 
                index={index + 1}
                blockUpdates={this.state.blockUpdates} //used to prevent render when updating task order
                disabled={this.state.currentTaskDeadline && todayForCheck != this.state.currentTaskDate} 
                key={index} 
                currentTaskDate={this.state.currentTaskDateObject}
                date={currentDate} 
                deadline={this.state.currentTaskDeadline}
                showInputMisc={this.showInputMisc}
                dark 
                past={past} />);
        }

        //create future days
        for (let index = 0; index < this.props.daysFuture; index++) {
            let currentDate;
            let past;

            if (this.props.centerDay) {
                currentDate = new Date(this.props.centerDay);
                currentDate.setDate(today.getDate()+index);
                currentDate.setHours(22);
                past = new Date() > currentDate;
            } else {
                currentDate = new Date();
                currentDate.setDate(today.getDate()+index);
                past = false;
            }

            let currentTaskDeadline = null;

            if (this.state.currentTaskDeadline) {
                currentTaskDeadline = this.state.currentTaskDeadline;
                currentTaskDeadline.setHours(22);
            }

            taskCards.push(<TaskCard 
                index={index + 1} 
                blockUpdates={this.state.blockUpdates} //used to prevent render when updating task order
                disabled={this.state.currentTaskDeadline && currentDate > currentTaskDeadline} 
                deadline={this.state.currentTaskDeadline} 
                currentTaskDate={this.state.currentTaskDateObject}
                showInputMisc={this.showInputMisc}
                key={index} 
                past={past}
                date={currentDate} 
                dark />);
        }
        return (
            <div styleName='planning-background'>

                <Modal open={this.state.showInputMisc} onClose={this.hideInputMisc} center styles={{
                    modal: {
                        background: 'none',
                        boxShadow: 'none'
                    },
                    closeIcon: {
                        fill: '#fff',
                        cursor: 'pointer'
                    }
                }}>
                    <InputMisc date={this.state.inputMiscDate} handleClose={this.hideInputMisc}/>
                </Modal>

                <div id='planning-fold' styleName='planning-top'>
                    <div styleName='left'>
                        <h1 styleName='title-wrapper' onClick={switchPlanning}>Takenlijst &amp; <div styleName='bold'>Planning <div styleName='fold-button'><FontAwesomeIcon style={ showPlanning ? {transform: 'rotate(180deg)'} : null} icon={faChevronDown}/></div></div></h1>
                    </div>
                    <div styleName={`right ${showPlanning ? 'visible' : ''}`}>
                        <div styleName='popup-wrapper' ref={this.setWrapperRef} onClick={this.togglePopup}>
                            <FontAwesomeIcon styleName='icon' icon={[ 'far', 'ellipsis-h' ]}/>
                            <div styleName={`popup ${this.state.showPopup ? '' : 'hidden'}`}>
                                <Checkbox hoverCheck style={{ justifyContent: 'flex-start', height: '17px', paddingLeft: '10px', marginTop: '5px', width: '100px' }} handleClick={this.props.toggleOtherTaskVisible} checked={this.props.agendaVisibility.other_task} label='Overige taken'/>
                                {this.props.user.use_timer ? <Checkbox hoverCheck style={{ justifyContent: 'flex-start', height: '17px', paddingLeft: '10px', width: '100px' }} handleClick={this.props.toggleTimeVisible} checked={this.props.agendaVisibility.time} label='Tijd'/> : null}
                            </div>
                        </div>
                    </div>
                </div>
                <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
                    <div id='planning' onScroll={() => scrollHandler && scrollHandler('Planning')} styleName={'planning ' + (showPlanning ? 'visible' : '')}>

                        {
                            taskCards
                        }
                    </div>
                    <Plannables visible={showPlanning}/>
                    {
                        this.state.showTip && <Tip tip={tipsArray[this.state.showTip]} close={this.closeTip} />
                    }

                </DragDropContext>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Planning);
